module.exports = __webpack_public_path__ + "components/flag/static/square/gd-43662bddde0a9fad49d97c79e6b669e1.svg";